import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getInsuranceID from 'utils/print/getInsuranceID';
import getPrescriberName from 'utils/print/getPrescriberName';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getSupplierName from 'utils/print/getSupplierName';
import getFacilityAddress from 'utils/print/getFacilityAddress';
import getInquiringProviderUserFirstName from 'utils/print/getInquiringProviderUserFirstName';
import getInquiringProviderUserLastName from 'utils/print/getInquiringProviderUserLastName';
import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';
import getOrderLineDescription from 'utils/print/getOrderLineDescription';
import getOrderLineCharge from 'utils/print/getOrderLineCharge';
import getOrderLineTotalCharge from 'utils/print/getOrderLineTotalCharge';

const PriorAuthorizationTemplateHFAuthorizationRequest = {
  ID: 24,
  Name: 'Health First Authorization Request',
  Type: 'Prior Authorization Template',
  Format: 'letter',
  Orientation: 'p',
  OrderLineMax: 13,
  WithCharge: true,
  Pages: [
    {
      ID: 2,
      imageUrl: 'assets/documents/Prior-Authorization-Template-Integra-Partners-Authorization-Request/2.js',
      fields: [
        {
          name: 'Integra Tax ID',
          type: 'text',
          x: 45,
          y: 47,
          width: 60,
        },
        {
          name: 'Integra NPI',
          type: 'text',
          x: 178,
          y: 47,
          width: 30,
        },
        {
          name: 'Within 30 Days?',
          type: 'checkbox',
          x: 202,
          y: 57,
          width: 4,
          height: 4,
        },
        {
          name: 'Auth Request Date 1',
          type: 'text',
          x: 47,
          y: 57,
          width: 7,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Auth Request Date 2',
          type: 'text',
          x: 55,
          y: 57,
          width: 7,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Auth Request Date 3',
          type: 'text',
          x: 63,
          y: 57,
          width: 7,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Date of RX / LMN 1',
          type: 'text',
          x: 122,
          y: 57,
          width: 7,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Date of RX / LMN 2',
          type: 'text',
          x: 130,
          y: 57,
          width: 7,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Date of RX / LMN 3',
          type: 'text',
          x: 138,
          y: 57,
          width: 7,
          normalize: normalize.positiveNumber,
        },

        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 56,
          y: 71.5,
          width: 145,
        },
        {
          name: 'DATE OF BIRTH',
          type: 'text',
          getValue: getPatientFullDob,
          x: 56,
          y: 78.5,
          width: 145,
        },
        {
          name: 'Patient ID',
          type: 'text',
          getValue: getInsuranceID,
          x: 56,
          y: 85,
          width: 145,
        },
        {
          name: 'REFERRING DOCTOR',
          type: 'text',
          getValue: getPrescriberName,
          x: 56,
          y: 92.5,
          width: 145,
        },
        {
          name: 'DIAGNOSIS',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 56,
          y: 99.5,
          width: 145,
        },
        {
          name: 'Prescription',
          type: 'checkbox',
          x: 10.5,
          y: 118,
          width: 3,
          height: 3,
        },
        {
          name: 'Prescription Signed',
          type: 'checkbox',
          x: 48,
          y: 118,
          width: 3,
          height: 3,
        },
        {
          name: 'Prescription Dated',
          type: 'checkbox',
          x: 86,
          y: 118,
          width: 3,
          height: 3,
        },
        {
          name: 'LMN',
          type: 'checkbox',
          x: 10.5,
          y: 124,
          width: 3,
          height: 3,
        },
        {
          name: 'LMN Signed',
          type: 'checkbox',
          x: 48,
          y: 124,
          width: 3,
          height: 3,
        },
        {
          name: 'LMN Dated',
          type: 'checkbox',
          x: 86,
          y: 124,
          width: 3,
          height: 3,
        },
        {
          name: 'Diabetic Shoe Certification',
          type: 'checkbox',
          x: 10.5,
          y: 130.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Sleep Study (Respiratory Only)',
          type: 'checkbox',
          x: 10.5,
          y: 136.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Evaluation Form (Prosthetics / Wheelchairs)',
          type: 'checkbox',
          x: 10.5,
          y: 143,
          width: 3,
          height: 3,
        },
        {
          name: 'Additional information LAST NAME',
          type: 'text',
          getValue: getInquiringProviderUserLastName,
          x: 10,
          y: 159.5,
          width: 53,
        },
        {
          name: 'Additional information FIRST NAME',
          type: 'text',
          getValue: getInquiringProviderUserFirstName,
          x: 67,
          y: 159.5,
          width: 53,
        },
        {
          name: 'Additional information CONTACT PHONE 1',
          type: 'text',
          getValue: getSupplierPhone1,
          x: 129,
          y: 159.5,
          width: 13,
          maxLength: 3,
        },
        {
          name: 'Additional information CONTACT PHONE 2',
          type: 'text',
          getValue: getSupplierPhone2,
          x: 145,
          y: 159.5,
          width: 13,
          maxLength: 3,
        },
        {
          name: 'Additional information CONTACT PHONE 3',
          type: 'text',
          getValue: getSupplierPhone3,
          x: 163,
          y: 159.5,
          width: 13,
          maxLength: 4,
        },
        {
          name: 'PROVIDER FACILITY NAME',
          type: 'text',
          getValue: getSupplierName,
          x: 10,
          y: 171,
          width: 73,
        },
        {
          name: 'PROVIDER FACILITY ADDRESS',
          type: 'text',
          getValue: getFacilityAddress,
          x: 94,
          y: 171,
          width: 110,
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reduce((accumulator, currentValue) => {
          const y = 190 + (currentValue * 6.4);
          return [
            ...accumulator,
            {
              name: `HCPC Code ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineHCPCSCode({ ...props, index: currentValue }),
              x: 12,
              y,
              width: 25,
            },
            {
              name: `Description ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDescription({ ...props, index: currentValue }),
              x: 41,
              y,
              width: 88,
            },
            {
              name: `QUANTITY ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue }),
              x: 131,
              y,
              width: 23,
              normalize: normalize.number,
            },
            {
              name: `PRICE ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineCharge({ ...props, index: currentValue }),
              x: 157,
              y,
              width: 23,
              normalize: normalize.price,
              chargeField: true,
            },
            {
              name: `TOTAL ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineTotalCharge({ ...props, index: currentValue }),
              x: 182,
              y,
              width: 23,
              normalize: normalize.price,
              chargeField: true,
            },
          ];
        }, []),
      ],
      texts: [
        {
          name: 'Address',
          getText: () => '1701 Utica Avenue, Brooklyn, NY 11234',
          x: 108,
          y: 15,
          align: 'center',
          fontSize: 12,
          lineHeight: 1.2,
        },
        {
          name: 'Address Phone',
          getText: () => 'Tel 718.369.0012 Fax 718.287.1229',
          x: 108,
          y: 19,
          align: 'center',
          fontSize: 12,
          lineHeight: 1.2,
        },
        {
          name: 'Email',
          getText: () => 'administration@integrah.com',
          x: 108,
          y: 23,
          align: 'center',
          fontSize: 12,
          lineHeight: 1.2,
        },
      ],
    },
    {
      ID: 1,
      imageUrl: 'assets/documents/Prior-Authorization-Template-Integra-Partners-Authorization-Request/1.js',
      fields: [
        {
          name: 'ATTENTION',
          type: 'text',
          x: 42,
          y: 83,
          width: 64,
        },
        {
          name: 'From',
          type: 'text',
          x: 153,
          y: 83,
          width: 47,
        },
        {
          name: 'COMPANY',
          type: 'text',
          x: 40,
          y: 91,
          width: 66,
        },
        {
          name: 'Date',
          type: 'text',
          x: 123,
          y: 91,
          width: 67,
          normalize: normalize.date,
        },
        {
          name: 'Fax',
          type: 'text',
          x: 28,
          y: 100,
          width: 78,
          normalize: normalize.phone,
        },
        {
          name: 'Pages',
          type: 'text',
          x: 125,
          y: 100,
          width: 65,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Phone',
          type: 'text',
          x: 34,
          y: 108,
          width: 72,
          normalize: normalize.phone,
        },
        {
          name: 'Re',
          type: 'text',
          x: 117,
          y: 108,
          width: 82,
        },
        {
          name: 'URGENT',
          type: 'checkbox',
          x: 18,
          y: 134,
          width: 3,
          height: 3,
        },
        {
          name: 'FOR REVIEW',
          type: 'checkbox',
          x: 57,
          y: 134,
          width: 3,
          height: 3,
        },
        {
          name: 'PLEASE COMMENT',
          type: 'checkbox',
          x: 94,
          y: 134,
          width: 3,
          height: 3,
        },
        {
          name: 'PLEASE REPLY',
          type: 'checkbox',
          x: 157.5,
          y: 134,
          width: 3,
          height: 3,
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7].reduce((accumulator, currentValue) => {
          const y = 176 + (currentValue * 7.4);
          return [
            ...accumulator,
            {
              name: `COMMENTS ${currentValue}`,
              type: 'text',
              x: 20,
              y,
              width: 178,
            },
          ];
        }, []),
      ],
      texts: [
        {
          name: 'Address',
          getText: () => '1701 Utica Avenue, Brooklyn, NY 11234',
          x: 108,
          y: 35,
          align: 'center',
          fontSize: 12,
          lineHeight: 1.2,
        },
        {
          name: 'Address Phone',
          getText: () => 'Tel 718.369.0012 Fax 718.287.1229',
          x: 108,
          y: 39,
          align: 'center',
          fontSize: 12,
          lineHeight: 1.2,
        },
      ],
    },
  ],
};

export default PriorAuthorizationTemplateHFAuthorizationRequest;



// WEBPACK FOOTER //
// ./src/config/documents/Prior-Authorization-Template-HF-Authorization-Request.js